import React from "react";
import { CAT_BADGE, stageCat, stageLabel } from "@/lib/funnel";

export function StageBadge({ stage, className = "" }) {
  const cat = stageCat(stage);
  return (
    <span
      data-testid={`stage-badge-${stage}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${CAT_BADGE[cat]} ${className}`}
    >
      {stageLabel(stage)}
    </span>
  );
}

export function OverdueBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold bg-red-100 text-red-700 border border-red-200 uppercase tracking-wide">
      Overdue
    </span>
  );
}
